import { createApp } from 'vue';
import WebpToJpgConverter from '../Components/WebpToJpgConverter.vue';

const root = document.getElementById('webp-to-jpg-converter');
if (root) {
  createApp(WebpToJpgConverter).mount('#webp-to-jpg-converter');
}
